/**
*  TheResolutionArea.vue of project WeTradeWeb
*  @date 2022/5/24 16:53
*  @author 阿佑[ayooooo@petalmail.com]
*/
<template>
<TheResolutionBar>
  <div class="df-middle">
    <div class="select-wrap" @click.stop="listExpand = !listExpand">
      <div class="select-op df-middle df-between br-sm pl-4">
        <Pic src="icons/brush" width="16" height="16" />
        <Pic src="icons/expand" width="16" height="16" />
      </div>
      <div class="options" v-if="listExpand">
        <div class="opt-item df-middle"
          v-for="(item, index) in drawTypes" :key="index"
          @click="$emit('draw', item.key)">
          <Pic :src="item.icon" class="mr-8" width="16" height="16" />
          <t :path="item.label">{{ item.title }}</t>
        </div>
      </div>
    </div>
    <div class="flex-1"></div>
    <div class="rotate" @click="$emit('fullscreen')">
      <Pic src="trade/rotate" width="16" height="16" />
    </div>
  </div>
</TheResolutionBar>
</template>

<script lang="ts">
import TheResolutionBar from '@/modules/market/components/chart/TheResolutionBar.vue'
import Pic from '@/components/Pic.vue'
import { defineComponent, shallowRef } from 'vue'

export default defineComponent({
  name: 'TheResolutionArea',
  components: {
    Pic,
    TheResolutionBar,
  },
  setup () {
    const listExpand = shallowRef(false)

    const drawTypes = [{
      title: 'Horizontal line',
      lable: '',
      icon: 'icons/line',
      key: 'line',
    }, {
      title: 'Trend line',
      lable: '',
      icon: 'icons/segment',
      key: 'segment',
    }, {
      title: 'Arrow Up',
      lable: '',
      icon: 'icons/arrow_up',
      key: 'up',
    }, {
      title: 'Arrow Down',
      lable: '',
      icon: 'icons/arrow_down',
      key: 'down',
    }, {
      title: 'Text',
      lable: '',
      icon: 'icons/text',
      key: 'text',
    }]

    document.addEventListener('click', () => {
      if (listExpand.value) {
        listExpand.value = false
      }
    })

    return {
      listExpand,
      drawTypes,
    }
  },
})
</script>

<style scoped lang="scss">
.select-wrap {
  position: relative;
}

.select-op {
  border: 1px solid var(--color-border);
  width: 40px;
  height: 20px;
  cursor: pointer;
}

.options {
  position: absolute;
  top: 24px;
  left: 0;
  background: #FFFFFF;
  box-shadow: 0 0 4px 0 rgba(10, 31, 68, 0.5);
  border-radius: 4px;
  z-index: 2;
  padding-bottom: 4px;

  .opt-item {
    cursor: pointer;
    height: 24px;
    min-width: 150px;
    margin-top: 4px;
    padding: 0 10px;
  }

  .opt-item:hover {
    background: #f4f6f8;
  }
}
</style>
